import { supabase } from '../lib/supabase';

class StorageService {
  constructor(bucketName) {
    this.bucketName = bucketName;
  }

  async uploadFile(file, folder = '') {
    try {
      const { data: { user }, error: authError } = await supabase?.auth?.getUser();
      if (authError || !user) {
        throw new Error('User not authenticated');
      }

      const fileExt = file?.name?.split('.')?.pop();
      const fileName = `${Date.now()}-${Math.random()?.toString(36)?.substring(7)}.${fileExt}`;
      const filePath = folder ? `${folder}/${fileName}` : fileName;

      const { data, error } = await supabase?.storage?.from(this.bucketName)?.upload(filePath, file, {
          cacheControl: '3600',
          upsert: false
        });

      if (error) throw error;

      return { data: { path: data?.path }, error: null };
    } catch (error) {
      console.error('Upload error:', error);
      return { data: null, error };
    }
  }

  async getSignedUrl(filePath, expiresIn = 3600) {
    try {
      if (!filePath) return { data: null, error: new Error('File path is required') };

      const { data, error } = await supabase?.storage?.from(this.bucketName)?.createSignedUrl(filePath, expiresIn);

      if (error) throw error;

      return { data: { signedUrl: data?.signedUrl }, error: null };
    } catch (error) {
      console.error('Get signed URL error:', error);
      return { data: null, error };
    }
  }

  async deleteFile(filePath) {
    try {
      const { data: { user }, error: authError } = await supabase?.auth?.getUser();
      if (authError || !user) {
        throw new Error('User not authenticated');
      }

      if (!filePath) return { error: new Error('File path is required') };

      const { error } = await supabase?.storage?.from(this.bucketName)?.remove([filePath]);

      if (error) throw error;

      return { error: null };
    } catch (error) {
      console.error('Delete error:', error);
      return { error };
    }
  }

  async listFiles(folder = '', options = {}) {
    try {
      const { data, error } = await supabase?.storage?.from(this.bucketName)?.list(folder, {
          limit: options?.limit || 100,
          offset: options?.offset || 0,
          sortBy: options?.sortBy || { column: 'name', order: 'asc' }
        });

      if (error) throw error;

      return { data, error: null };
    } catch (error) {
      console.error('List files error:', error);
      return { data: null, error };
    }
  }
}

export const playerMediaStorage = new StorageService('player-media');
export const performanceMediaStorage = new StorageService('performance-media');

export default StorageService;